import styled from "styled-components";
import TextareaAutosize from "react-autosize-textarea";

export const StyledTextarea = styled(TextareaAutosize)`
  width: 100%;
  min-height: 95%;
  box-sizing: border-box;
  padding: 0;
  font-size: inherit;
  resize: none;
  &:disabled {
    background-color: transparent;
  }
  ::placeholder {
    color: ${({ theme: { colors } }) => colors["hoki-25"]};
  }
`;
